import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive", "orderDir"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { pxToRem, getBackgroundShade } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import { Arrow as ArrowIcon } from 'components/icons';
import ButtonCore from 'components/ButtonCore';
import VisuallyHidden from 'components/VisuallyHidden';
import { getColumnName } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.span.withConfig({
  displayName: "ClickableHeader__Wrapper",
  componentId: "sc-dkvbfi-0"
})(["vertical-align:baseline;padding-right:", ";"], function (p) {
  return p.theme.globals.spacing.xxs;
});
var shouldForwardProp = function shouldForwardProp(prop) {
  return !['isActive', 'isSortable'].includes(prop);
};
var ClickabilityIndicator = styled(ButtonCore).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ClickableHeader__ClickabilityIndicator",
  componentId: "sc-dkvbfi-1"
})(["margin-left:", ";vertical-align:0;&::before{content:'';position:absolute;width:", ";height:", ";margin-top:", ";margin-left:", ";background-color:currentcolor;border-radius:50%;opacity:", ";transition:opacity 0.15s ease-in-out 0.15s;}&:hover::before,&.focus-visible::before{opacity:0;transition-delay:0s;}&::after{content:'';", "}"], function (p) {
  return p.theme.globals.spacing.xxs;
}, pxToRem(4), pxToRem(4), pxToRem(8), pxToRem(5), function (p) {
  return p.isActive ? 0 : 0.5;
}, fillParent);
var StyledSortArrow = styled(ArrowIcon).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ClickableHeader__StyledSortArrow",
  componentId: "sc-dkvbfi-2"
})(["border-radius:50%;transition-property:all;", " ", ":hover &&,", ".focus-visible &&{fill:", ";opacity:1;transition-delay:0.15s;background-color:", ";box-shadow:0 0 0 3px ", ";}"], function (p) {
  return !p.isActive && css(["opacity:0;"]);
}, ClickabilityIndicator, ClickabilityIndicator, function (p) {
  return p.theme.links;
}, function (p) {
  return getBackgroundShade(p.theme);
}, function (p) {
  return getBackgroundShade(p.theme);
});
function SortArrow(_ref) {
  var isActive = _ref.isActive,
    orderDir = _ref.orderDir,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ClickabilityIndicator, _objectSpread(_objectSpread({}, otherProps), {}, {
    isActive: isActive,
    children: /*#__PURE__*/_jsx(StyledSortArrow, {
      vAlign: true,
      dimmed: true,
      isActive: isActive,
      scale: 0.8,
      rotate: orderDir === 'desc' ? -90 : 90
    })
  }));
}
var reverseOrder = {
  asc: 'desc',
  desc: 'asc'
};
var orderLabels = {
  asc: 'sortedAsc',
  desc: 'sortedDesc'
};
function ClickableHeader(_ref2) {
  var isActive = _ref2.isActive,
    column = _ref2.column,
    order = _ref2.order,
    a11yLabels = _ref2.a11yLabels,
    onRequestSort = _ref2.onRequestSort,
    children = _ref2.children;
  var columnName = getColumnName(column);

  // Only flip the order when the column to be ordered by doesn't change.
  // Otherwise use the column's `defaultOrder` prop
  var newOrder = isActive && order ? reverseOrder[order] : column.defaultOrder || 'asc';
  function getSortHandler() {
    if (typeof onRequestSort !== 'function') return null;
    return function () {
      onRequestSort({
        column: column.name || column.title,
        order: newOrder
      });
    };
  }
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [children, isActive && order && /*#__PURE__*/_jsx(VisuallyHidden, {
      children: "(".concat(a11yLabels[orderLabels[order]], ")")
    }), /*#__PURE__*/_jsx(SortArrow, {
      isActive: isActive,
      orderDir: isActive ? order : column.defaultOrder,
      onClick: getSortHandler(),
      "aria-label": a11yLabels.sortByColumn(columnName, newOrder)
    })]
  });
}
export default ClickableHeader;